<template>
    <v-row justify="center">
        <v-dialog
            v-model="modal"
            :persistent='true'
            width="50%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="pageTitle" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="form"
                            v-model="valid"
                            :lazy-validation="lazy"
                            >
                            <v-container>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">ゴルフ場</div>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            :items="golfCourses"
                                            item-value="golf_code"
                                            item-text="golf_name"
                                            v-model="input.golfCode"
                                            label="ゴルフ場名"
                                            :rules="[rules.required]"
                                            disabled
                                        />
                                    </v-col>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">コース</div>
                                    <v-col>
                                        <v-select
                                            class="px-3"
                                            :items="courses"
                                            item-value="course_code"
                                            item-text="course_name"
                                            v-model="input.courseCode"
                                            label="コース"
                                            :rules="[rules.required]"
                                            :disabled="editMode"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">期間</div>
                                    <v-col cols="3">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="playDateStartMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    :rules="[
                                                        rules.required,
                                                        rules.check_start_date,
                                                        rules.correct_date,
                                                        rules.format_date
                                                    ]"
                                                    inputmode="tel"
                                                    type="tel"
                                                    placeholder="0000-00-00"
                                                    maxlength="10"
                                                    v-on="on"
                                                    v-model="formatedPlayStart"
                                                    @focus="focusDate(input.playDateStart)"
                                                    @keyup.delete="input.playDateStart = deleteKeyDelete($event)"
                                                    @keyup="input.playDateStart = formatDate(input.playDateStart)"
                                                    @keydown.tab.exact="playDateStartMenu = false"
                                                    :disabled="editMode"
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="input.playDateStart"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="playDateStartMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="3">
                                        <!--
                                        # 注意事項

                                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                        例）2021と入力すると、2021-20-21と入ってしまう。

                                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                        （date を指定するとカレンダーが表示されてしまう）
                                        -->
                                        <v-menu
                                            ref="menu"
                                            v-model="playDateValidMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="px-3"
                                                    :rules="[
                                                        rules.required,
                                                        rules.check_start_date,
                                                        rules.correct_date,
                                                        rules.format_date
                                                    ]"
                                                    v-model="formatedPlayValid"
                                                    maxlength="10"
                                                    inputmode="tel"
                                                    type="tel"
                                                    v-on="on"
                                                    placeholder="0000-00-00"
                                                    @focus="focusDate(input.playDateValid)"
                                                    @keyup.delete="input.playDateValid = deleteKeyDelete($event)"
                                                    @keyup="input.playDateValid = formatDate(input.playDateValid)"
                                                    @keydown.tab.exact="playDateValidMenu = false"
                                                    :disabled="editMode"
                                                />
                                            </template>
                                            <v-date-picker
                                                ref="picker"
                                                v-model="input.playDateValid"
                                                locale="jp-ja"
                                                :day-format="date => new Date(date).getDate()"
                                                min="1900-01-01"
                                                @input="playDateValidMenu = false"
                                            />
                                        </v-menu>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">開始時刻</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            class="px-3"
                                            :rules="[rules.required]"
                                            v-model="input.playTimeStart"
                                            type="time"
                                            maxlength="5"
                                        />
                                    </v-col>
                                    <div class="cardWrap__fromArea__title">終了時刻</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            class="px-3"
                                            :rules="[
                                                rules.required,
                                                rules.check_start_time
                                            ]"
                                            v-model="input.playTimeValid"
                                            type="time"
                                            maxlength="5"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔１</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            :rules="[
                                                rules.required,
                                                rules.check_int
                                            ]"
                                            class="px-3"
                                            v-model="input.interval1"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔２</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            class="px-3"
                                            v-model="input.interval2"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                            :disabled="disabledInterval2"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <div class="cardWrap__fromArea__title">間隔３</div>
                                    <v-col cols="3">
                                        <v-text-field
                                            inputmode="numeric"
                                            class="px-3"
                                            v-model="input.interval3"
                                            type="number"
                                            suffix="分"
                                            max="99"
                                            min="0"
                                            :disabled="disabledInterval3"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="closeModal">閉じる</v-btn>
                        <v-btn color="green darken-4" text @click="validateCheck">
                            <template v-if="editMode">
                                {{ modeEdit }}
                            </template>
                            <template v-else>
                                {{ modeAdd }}
                            </template>
                        </v-btn>
                    </v-card-actions>
                    <v-overlay :value="overlaySwitch">
                        <v-card light width="500px">
                            <v-card-title>基本枠作成処理</v-card-title>
                            <v-card-text v-if="!process.processing" class="py-1">基本枠を{{ modeStatus }}します。</v-card-text>
                            <v-card-text v-if="!process.processing" class="pt-1 redText" :class="{'redText': modeStatus === modeEdit}">作成後にプランの枠連携、料金連携を行ってください。</v-card-text>
                            <v-card-text v-if="process.processing" :class="{'redText': !process.result}">{{ process.resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn v-if="!process.processing" color="primary" text @click="overlaySwitch = !overlaySwitch">閉じる</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn v-if="!process.processing" color="primary" text @click="clickEvent()">実行</v-btn>
                                <v-btn v-if="process.processing && process.result" color="primary" text @click="closeModal()">閉じる</v-btn>
                                <v-btn v-if="process.processing && !process.result" color="primary" text @click="overlaySwitch = !overlaySwitch">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { utilityMixin } from '@/mixins/utility';
import validater from '@/lib/validater';
// コンポーネント
import CardTitle from '@/components/module/CardTitle';

// graphql
import {
    GET_CELL_BASE,
    CREATE_CELL_BASES,
    UPDATE_CELL_BASES
} from '@/constants/cell_bases';
import { GET_COURSE_LIST } from '@/constants/plan';

export default {
    components: {
        CardTitle
    },
    mixins: [
        utilityMixin
    ],
    props: {
        golfCourses: {
            type: Array,
            required: true
        },
        golfCode: {
            type: String
        },
        id: {
            type: String
        },
        modal: {
            type: Boolean
        },
        modeStatus: {
            // "追加" | "変更"
            type: String,
            required: true
        }
    },
    data () {
        return {
            // ゴルフグループコード
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 処理確認用ポップアップ表示に関する制御値
            overlaySwitch: false,
            // 必須項目に関するチェック値
            valid: true,
            // バリデーションチェック値
            lazy: true,
            // コースリスト
            courses: [],
            // 入力値管理用
            input: {
                // ゴルフコード
                golfCode: '',
                // コースコード
                courseCode: '',
                // 期間From
                playDateStart: '',
                // 期間to
                playDateValid: '',
                // 開始時刻
                playTimeStart: '',
                // 終了時刻
                playTimeValid: '',
                // 間隔
                interval: '',
                interval1: '',
                interval2: '',
                interval3: ''
            },
            process: {
                // 処理結果
                result: false,
                // 処理結果メッセージ
                resultText: '',
                // 処理状態
                processing: false
            },
            rules: {
                // 氏名（姓）バリデーション
                required: value => !!value || this.$t('error.validation.required.any'),
                check_start_date: value => this.checkStartDate(value) || this.$t('error.validation.time.some'),
                check_start_time: value => this.checkCorrectTimeHours(value) || this.$t('error.validation.time.correct'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                check_int: value => validater.checkIntType(value) || this.$t('error.validation.intType')
            },
            modeAdd: '追加',
            modeEdit: '変更',
            playDateStartMenu: false,
            playDateValidMenu: false
        };
    },
    computed: {
        pageTitle () {
            if (this.modeStatus === this.modeAdd) {
                return '基本枠作成';
            }
            return '基本枠編集';
        },
        editMode () {
            return this.modeStatus === this.modeEdit;
        },
        formatedPlayStart: {
            get () {
                return this.input.playDateStart;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.playDateStart = value;
            }
        },
        formatedPlayValid: {
            get () {
                return this.input.playDateValid;
            },
            set (value) {
                value = this.addHyphen(value);
                this.input.playDateValid = value;
            }
        },
        disabledInterval2 () {
            return !this.input.interval1;
        },
        disabledInterval3 () {
            return !(this.input.interval1 && this.input.interval2);
        }
    },
    watch: {
        result () {
            if (this.process.result === 1) {
                this.process.resultText = this.$t('result.success.change');
            } else if (this.result === 0) {
                this.process.resultText = this.$t('result.error.change');
            }
        },
        id (val) {
            this.Initialize();
            this.input.golfCode = this.golfCode;
            if (val !== '' && val !== null) {
                this.getDetail(val);
            }
        },
        'input.golfCode' (val) {
            this.getCourseList();
        },
        /** ----------------------------------------------
         * interval2が空なら、interval3を空にする。
         * ---------------------------------------------- */
        'input.interval2' (val) {
            if (val === '') {
                this.input.interval3 = '';
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.$set(this.input, 'golfCode', '');
            this.$set(this.input, 'courseCode', '');
            this.$set(this.input, 'playDateStart', '');
            this.$set(this.input, 'playDateValid', '');
            this.$set(this.input, 'playTimeStart', '');
            this.$set(this.input, 'playTimeValid', '');
            this.$set(this.input, 'interval', '');
            this.$set(this.input, 'interval1', '');
            this.$set(this.input, 'interval2', '');
            this.$set(this.input, 'interval3', '');
            this.process.processing = false;
            this.process.result = false;
            this.process.resultText = '';
            this.overlaySwitch = false;
        },
        /** ----------------------------------------------
         * 詳細取得
         * ---------------------------------------------- */
        async getDetail (id) {
            this.$apollo.query({
                query: GET_CELL_BASE,
                fetchPolicy: 'no-cache',
                variables: { id: id }
            }).then(res => {
                const detail = res.data.getCellBaseDetail;
                this.setInput(detail);
            }).catch(e => {
                this.result = e;
                this.resultText = e;
            });
        },
        /** --------------------------------------------
         * コースを取得
         *-------------------------------------------- */
        async getCourseList () {
            this.$apollo.query({
                query: GET_COURSE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode
                }
            }).then(res => {
                this.courses = res.data.GetCoursesList;
            }).catch(e => {
                this.error = e;
            });
        },
        /** --------------------------------------------
         * 入力値をセット
         *-------------------------------------------- */
        setInput (detail) {
            this.input = {
                golfCode: detail.golf_code,
                courseCode: detail.course_code,
                playDateStart: detail.play_date_start,
                playDateValid: detail.play_date_valid,
                playTimeStart: detail.play_time_start,
                playTimeValid: detail.play_time_valid,
                interval: this.setInputInterval(detail.interval, 0),
                interval1: this.setInputInterval(detail.interval, 1),
                interval2: this.setInputInterval(detail.interval, 2),
                interval3: this.setInputInterval(detail.interval, 3)
            };
        },
        /** --------------------------------------------
         * 入力値をセット
         *-------------------------------------------- */
        setInterval (data) {
            let arr = [];
            let dispInterval = '';
            if (data.interval1) {
                arr[1] = data.interval1;
                dispInterval = data.interval1;
                if (data.interval2) {
                    arr[2] = data.interval2;
                    dispInterval = dispInterval + '-' + data.interval2;
                    if (data.interval3) {
                        arr[3] = data.interval3;
                        dispInterval = dispInterval + '-' + data.interval3;
                    }
                }
                arr[0] = dispInterval;
            }

            const str = JSON.stringify(arr);
            return str;
        },
        /** --------------------------------------------
         * 入力値をセット
         *-------------------------------------------- */
        setInputInterval (data, int) {
            const str = JSON.parse(JSON.stringify(data));
            const obj = JSON.parse(str);
            if (obj[int]) {
                return obj[int];
            } else {
                return '';
            }
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                this.process.processing = false;
                this.overlaySwitch = true;
            }
        },
        overlayClose () {
            this.overlaySwitch = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * 実行ボタン処理
         * ---------------------------------------------- */
        clickEvent () {
            if (this.modeStatus === this.modeAdd) {
                this.registData();
            } else if (this.modeStatus === this.modeEdit) {
                this.updateData();
            }
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        async registData () {
            this.$store.commit('loading/setIsLoading', true);
            let res = await this.createCellBases();
            this.process.processing = true;
            if (res === 1) {
                this.process.result = true;
                this.process.resultText = '正常に終了しました。';
            }
            this.$store.commit('loading/setIsLoading', false);
        },
        /** ----------------------------------------------
         * 更新処理
         * ---------------------------------------------- */
        async updateData () {
            this.$store.commit('loading/setIsLoading', true);
            let res = await this.updateCellBases();
            this.process.processing = true;
            if (res === 1) {
                this.process.result = true;
                this.process.resultText = '正常に終了しました。';
            }
            this.$store.commit('loading/setIsLoading', false);
        },
        /** ----------------------------------------------
         * 基本枠作成
         * ---------------------------------------------- */
        async createCellBases () {
            await this.$apollo.mutate({
                mutation: CREATE_CELL_BASES,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode,
                    course_code: this.input.courseCode,
                    play_date_start: this.input.playDateStart,
                    play_date_valid: this.input.playDateValid,
                    play_time_start: this.input.playTimeStart,
                    play_time_valid: this.input.playTimeValid,
                    interval: this.setInterval(this.input)
                }
            }).then(res => {
                this.result = res.data.createCellBases.result;
            }).catch(error => {
                if (error.graphQLErrors) {
                    const messages = error.graphQLErrors[0].extensions.validation;
                    const errorMessages = Object.keys(messages).flatMap(key => {
                        return messages[key];
                    });
                    this.result = errorMessages;
                    this.$set(this.process, 'result', 0);
                    this.$set(this.process, 'resultText', errorMessages.join('\n'));
                } else {
                    const errorMessage = error.message.split(/:/g);
                    this.result = errorMessage;
                    this.$set(this.process, 'result', 0);
                    this.$set(this.process, 'resultText', '変更に失敗しました。');
                }
                this.$store.commit('loading/setIsLoading', false);
            });
            return this.result;
        },
        /** ----------------------------------------------
         * 編集処理
         * ---------------------------------------------- */
        async updateCellBases () {
            this.$store.commit('loading/setIsLoading', true);
            await this.$apollo.mutate({
                mutation: UPDATE_CELL_BASES,
                variables: {
                    id: this.id,
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.input.golfCode,
                    course_code: this.input.courseCode,
                    play_date_start: this.input.playDateStart,
                    play_date_valid: this.input.playDateValid,
                    play_time_start: this.input.playTimeStart,
                    play_time_valid: this.input.playTimeValid,
                    interval: this.setInterval(this.input)
                }
            }).then(res => {
                this.result = res.data.updateCellBases.result;
            }).catch(error => {
                if (error.graphQLErrors) {
                    const messages = error.graphQLErrors[0].extensions.validation;
                    const errorMessages = Object.keys(messages).flatMap(key => {
                        return messages[key];
                    });
                    this.result = errorMessages;
                    this.$set(this.process, 'result', 0);
                    this.$set(this.process, 'resultText', errorMessages.join('\n'));
                } else {
                    const errorMessage = error.message.split(/:/g);
                    this.result = errorMessage;
                    this.$set(this.process, 'result', 0);
                    this.$set(this.process, 'resultText', '変更に失敗しました。');
                }
                this.$store.commit('loading/setIsLoading', false);
            });
            return this.result;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            this.overlayClose();
            this.$emit('refresh-event');
            this.$refs.form.resetValidation();
            this.Initialize();
        },
        /** --------------------------------------------
         * 終了日が開始日より前日になっていないか
         * -------------------------------------------- */
        checkStartDate () {
            if (this.input.playDateValid && this.input.playDateValid) {
                const start = new Date(this.input.playDateStart);
                const end = new Date(this.input.playDateValid);
                return start.getTime() <= end.getTime();
            } else {
                return true;
            }
        },
        /** --------------------------------------------
         * 終了時刻が開始時刻より前になっていないか
         * -------------------------------------------- */
        checkCorrectTimeHours () {
            if (this.input.playTimeStart && this.input.playTimeValid) {
                const start = this.formatTimeString(this.input.playTimeStart);
                const end = this.formatTimeString(this.input.playTimeValid);
                return Number(start) < Number(end);
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 時間フォーマット
         * 例 07:00:00 → 0700
         * ---------------------------------------------- */
        formatTimeString (item) {
            return item.split(':').splice(0, 2).join('');
        }
    }
};
</script>
<style scoped>
    .redText {
        color: red !important;
    }
</style>
